import { render, staticRenderFns } from "./CompanyTreePlantingReviewDirect.vue?vue&type=template&id=2afc0027&"
import script from "./CompanyTreePlantingReviewDirect.vue?vue&type=script&lang=js&"
export * from "./CompanyTreePlantingReviewDirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports